module.exports = __webpack_public_path__ + "img/cnc.cdd0034c.png";